import { twMerge } from 'tailwind-merge';

import { OddsLogicCredit } from '@/components/shared/OddsLogicCredit';

/**
 * "Odds by OddsLogic" credit for the results lists. It sits in the head of the section
 * whose lines it describes (#2142): beside Pending, where current lines show, with the
 * freshness note; otherwise beside Results, where the closing lines show, without it.
 */
export function OddsCredit({
  currentLines = false,
  className,
}: {
  // The section shows live current lines, so carry the "may be delayed" note.
  currentLines?: boolean;
  className?: string;
}) {
  return (
    <div className={twMerge('flex flex-col items-end gap-1', className)}>
      <OddsLogicCredit />
      {currentLines && (
        <span className="text-[11px] text-zinc-400 dark:text-zinc-500">
          Current lines may be delayed a few minutes
        </span>
      )}
    </div>
  );
}
